/* eslint-disable no-useless-escape */
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const UK_POSTCODE_REGEX = /^(?!GIR)([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;

export const DOB_YEAR_REGEX = /^(19[3-9][0-9]|20[0-9][0-9])$/;

export const SPECIAL_CHAR_REGEX = /^[a-zA-Z0-9._@-]+$/;

export const PASSWORD_REGEX =
  /^[a-zA-Z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+-\s]*$/;

export const NO_LEADING_TRAILING_SPACE = /^\S.*\S$|^\S$/;

export const CONTAINS_SPACE = /\s/;

export const minUsernameLength = 3;
export const maxUsernameLength = 100;

export const minPasswordLength = 12;
export const maxPasswordLength = 256;
